import React from 'react';
import PropTypes from 'prop-types';

import i18n from '../../../i18n';

const SortOrder = ({ value, onChange }) => (
    <div className="form-group sort-order">
        <i className="icon icon-sort-order icon-large" />
        <span className="sort-order-text">{i18n.t('search:sort_by_title')}</span>
        <div className="sort-order-select-container">
            <select
                className="form-control sort-order-select"
                name="sort"
                id="sort_type"
                value={value}
                onChange={onChange}
            >
                <option value="relevance">{i18n.t('search:sort_by_relevance')}</option>
                <option value="newest">{i18n.t('search:sort_by_newest')}</option>
                <option value="most_recent_availabilities">
                    {i18n.t('search:sort_by_most_recent_availabilities')}
                </option>
            </select>
            <i className="fa fa-angle-down down-arrow"></i>
        </div>
    </div>
);

SortOrder.propTypes = {
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    onChange: PropTypes.func.isRequired
};

export default SortOrder;
